import { registerFeatureWithDescription } from "lib/features"

/**
 * Gates the customer-visible conditional trade routing UI on skill maps.
 *
 * Resolver, persistence, and cost-breakdown surfacing ship without the flag (they
 * are no-ops when no line has conditionalTrades configured). The flag exists so the
 * authoring UI, the dry-run preview, and the breakdown filter chip stay hidden until
 * the full experience is end-to-end ready, per the brief.
 */
export const FEATURE_FLAG_OPTIMISER_CONDITIONAL_TRADES = registerFeatureWithDescription({
    numericalId: 3001,
    id: "optimiser-conditional-trades",
    name: "Optimiser: conditional trade routing",
    internalUseOnly: true,
    descriptionLines: [
        "Allows multiple trades to be assigned to a single SFG20 skill on a skill map line.",
        "At cost time the resolver walks an ordered list of conditional trades on each line; the first whose conditions match the task wins, otherwise the line's default trade is used.",
    ],
})
